import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSkProspektByUserid,setofUpdatedashboardProspekt,decrypt,encrypt } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardProspekt } = accountsData 
    const { SkProspekt,DashboardAnpassadFilterOption} = DashBoard;
    return {
        authUser,SkProspekt,DashboardAnpassadFilterOption,updatedashboardProspekt
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getSkProspektByUserid: (userid,Afid,DashboardAnpassadFilterOption,intervaltype) => dispatch(getSkProspektByUserid(userid,Afid,DashboardAnpassadFilterOption,intervaltype)),
        setofUpdatedashboardProspekt: () => dispatch(setofUpdatedashboardProspekt()),
        dispatch
    }
}


class SkapadProspekt extends Component {
    state={
        SkProspekt:0,
        DashboardAnpassadFilterOption:[],
        done: true
    }
    intervalID = null
    componentDidMount=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        axios.get(`kontos/DashBoard/getSKPROVMBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
            }))
        })
        .then(res => {
             if(res.data.success){
                            let endata = decrypt(res.data.encryptedData,res.data.iv)
                            let ndate = JSON.parse(endata)
                            this.setState({ 
                                SkProspekt:ndate.results.SkProspekt
                            });
                            this.initiateInterval() 
                            //this.setState({done: true})   
                        }
            
        })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                 //   this.setState({done: false})
                const userid = this.props.authUser.user_id;
                const Afid = this.props.authUser.user_Afid;
                axios.get(`kontos/DashBoard/getSKPROVMBU`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
            }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    SkProspekt:ndate.results.SkProspekt
                });
                this.initiateInterval() 
                //this.setState({done: true})   
            }
        })
            }
            },
            180000
        );
        
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    componentDidUpdate=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboardProspekt) === 1){
            axios.get(`kontos/DashBoard/getSKPROVMBU`,
            { params:encrypt(JSON.stringify({
                Afid:Afid,
                FilterOption:[],
                intervaltype:this.props.intervaltype,
                userid:userid
                }))
            })
            .then(res => {
                if(res.data.success){
                    let endata = decrypt(res.data.encryptedData,res.data.iv)
                    let ndate = JSON.parse(endata)
                    this.setState({ 
                        SkProspekt:ndate.results.SkProspekt
                    });
                    this.initiateInterval() 
                    //this.setState({done: true})   
                } 
            })
            this.props.setofUpdatedashboardProspekt()
        }
      
    }
    formatNumber=(number)=>{
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
   }
    render() {
        //const formatter = new Intl.NumberFormat('fr',{ notation: "compact" , compactDisplay: "short" })
        return (<>{
            this.state.done === false?
            <Skeleton variant="rectangular"  height={'90%'} style={{margin:10,backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
            :
          <div className="text-center d-flex flex-column justify-content-between align-items-center h-100 w-100 px-3 py-1" style={{ color: 'white' }}>
            <div className="d-flex justify-content-center row w-100" style={{ marginTop: this.props.isFrom === 1 ? '5px' : '2px' }}>
              <h2 className="m-0"  style={{fontWeight:"500",
              color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor
              , fontSize: this.props.isFrom ===  1 ? '16px' : '20px'}}><b><IntlMessages id="DashBoard.Created.Prospectus"/></b></h2>
            </div>
            <div className='w-100'>
                <p className="w-100 text-center" style={{ fontSize: this.props.isFrom === 1 ? 55 : 85, lineHeight:1,
                    color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor,
                    fontWeight:"500", '-webkit-text-stroke': '2px #54F3E3'  }}>
                {this.formatNumber(parseInt(this.state.SkProspekt))}
                </p>
            </div>
            <div className="d-flex justify-content-end w-100" style={{color:isUndefined(this.props.FontColor)?'#ffffff':this.props.FontColor}}>
                <p>{this.props.getIntervalTypeText(this.props.intervaltype)}</p>
            </div>
          </div>
    }</>
        )
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
)(SkapadProspekt);